// @flow
import React from 'react';
import moment from 'moment';
import { Elements } from 'react-stripe-elements';
import { formatCentsToDollars } from 'clark-utils';

import SectionHeader from 'components/shared/section-header';
import InfoCard from 'components/shared/info-card';
import Layout from 'components/shared/layout';

import ChargeForm from 'containers/payer/charge-form';

import { Container, BillDetail, Logo, Wrapper } from './styles';

const statusTypes = {
  pending: {
    type: 'default',
    text: 'Not Paid',
  },
  complete: {
    type: 'low',
    text: 'Paid',
  },
  failed: {
    type: 'high',
    text: 'Failed',
  },
};

const infoCard = (charge, payer) => {
  const {
    attributes: { status, customNote, receiptId, createdAt, totalAmountInCents },
  } = charge;
  const { attributes: payerAttrs } = payer;
  const { firstName, lastName } = payerAttrs;
  const { type, text } = statusTypes[status];
  const date = moment(createdAt).format('MMM Do, YYYY');

  return {
    headline: `${firstName} ${lastName}`,
    subHeadline: '',
    chargeDetails: {
      amount: formatCentsToDollars(totalAmountInCents),
      description: customNote,
      status: {
        type,
        text,
      },
    },
    metaDetails: [
      {
        title: 'Bill',
        data: receiptId,
      },
      {
        title: 'Date',
        data: date,
      },
    ],
  };
};

const Charge = ({
  handlePlaidSuccess,
  business,
  charge,
  payer,
  handleClick,
  logoUrl,
  pendingBankAccountAttributes,
  showNewCreditCardForm,
  toggleCreditCardForm,
}: any) => {
  const { chargeDetails, metaDetails, headline, subHeadline } = infoCard(charge, payer);
  const {
    attributes: { status: chargeStatus },
  } = charge;

  const showForm = chargeStatus !== 'complete';

  return (
    <Container>
      <Layout>{logoUrl && <Logo src={logoUrl} alt="logo" />}</Layout>
      <Wrapper>
        <BillDetail>
          <Layout>
            <SectionHeader
              headline={`Your tutoring bill from ${business.attributes.name}`}
              textAlign="center"
            />
            <InfoCard
              headline={headline}
              subHeadline={subHeadline}
              details={metaDetails}
              charge={chargeDetails}
            />
          </Layout>
        </BillDetail>
        {showForm && (
          <Elements>
            <ChargeForm
              charge={charge}
              handleClick={handleClick}
              handlePlaidSuccess={handlePlaidSuccess}
              pendingBankAccountAttributes={pendingBankAccountAttributes}
              showNewCreditCardForm={showNewCreditCardForm}
              toggleCreditCardForm={toggleCreditCardForm}
              initialValues={{
                autopayEnabled: true,
              }}
            />
          </Elements>
        )}
      </Wrapper>
    </Container>
  );
};

export default Charge;



// WEBPACK FOOTER //
// ./src/components/payer/charge/index.js